export function urlToState (url) {
  if (url.split('?')[0].split('/')[1] === 'favourites') {
    return { filter: 'favourites=true' }
  }

  const [, s, locationPuzzle, query, center, zoom, perPage, page, filter] = url.split('?')[0].split('/')

  if (s !== 's') {
    throw new Error('Bad URL')
    // something is wrong then...
  }

  return { locationPuzzle, query, center, zoom, perPage, page, filter }
}

export function stateToUrl ({ locationPuzzle, query, center, zoom, perPage, page, filter }) {
  if (filter.split('&').includes('favourites=true')) {
    return '/favourites'
  }

  return ['', 's', locationPuzzle, query, center, zoom, perPage, page, filter].join('/').replace(/\/+$/, '')
}

export function getKeyFromFilter (url, key) {
  const state = urlToState(url)

  const filterParts = {}

  ;(state.filter || '')
    .split('&')
    .map(p => p.split('='))
    .forEach(([k, v]) => {
      filterParts[k] = v
    })

  return filterParts[key]
}

export function updateFilterInSearchPath (url, filterKey, filterValue) {
  const state = urlToState(url)

  const filterParts = {}

  ;(state.filter || '')
    .split('&')
    .map(p => p.split('='))
    .forEach(([k, v]) => {
      filterParts[k] = v
    })

  filterParts[filterKey] = filterValue

  state.filter = Object.keys(filterParts)
    .filter(k => filterParts[k])
    .map(k => `${k}=${filterParts[k]}`)
    .join('&')

  return stateToUrl(state)
}
